import {Component} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {CompanyService} from '../../../../../../@shared/services/company.service';
import {COR_COY_1} from '../../../../../../@shared/models/input.module';
import {StorageService} from '../../../../../../@core/services/storage.service';

@Component({
  selector: 'app-create-organisation',
  standalone: false,
  templateUrl: './create-organisation.html',
  styleUrl: './create-organisation.css'
})
export class CreateOrganisation {
  companyName: string = ''
  organisationNumber: string = ''
  address: string = ''
  city: string = ''
  postalCode: string = ''
  country: string = ''
  phone: string = ''
  email: string = ''
  description: string = ''

  loading: boolean = false

  constructor(
    public activeModal: NgbActiveModal,
    private companyService: CompanyService,
    private storageService: StorageService
  ) {}

  createOrganisation() {
    if (!this.companyName) {
      alert('Company name is required')
      return
    }

    this.loading = true

    const payload: COR_COY_1 = {
      company_name: this.companyName,
      organisation_number: this.organisationNumber,
      address: this.address,
      city: this.city,
      postal_code: this.postalCode,
      country: this.country,
      phone: this.phone,
      email: this.email,
      user_id: this.storageService.getUser().user_id
    }

    this.companyService.createCompany(payload).subscribe({
      next: (company) => {
        this.loading = false
        this.activeModal.close(company)
      },
      error: (error) => {
        this.loading = false
        console.error('Error creating organisation:', error)
      }
    })
  }

  close() {
    this.activeModal.dismiss()
  }
}
